import { Collapse } from '@material-ui/core';
import React from 'react';
import styled from 'styled-components';
import { FontAwesomeSpriteButton } from 'src/modules/shared/components/FontAwesomeLocal';

const MARGIN_OVERLAP = 5.5;

export const PanelWrapper = styled(({ context, embedded, ...restProps }) => <div {...restProps} />)`
  position: relative;
  background: #fff;
  padding: 2rem 3rem 3rem 3rem;
  box-shadow: ${({ theme, embedded }) => (embedded ? 'none' : theme.config.defaultBoxShadow)};
  border-bottom: ${({ theme, embedded }) =>
    embedded ? `.1rem solid ${theme.palette.grey['100']}` : 'none'};

  &:before {
    content: '';
    display: ${({ embedded }) => (embedded ? 'none' : 'block')};
    position: absolute;
    top: ${({ context }) => (context === 'block' ? '100%' : '0')};
    right: 1.5rem;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0.75rem;
    border-color: transparent transparent #fff #fff;
    transform-origin: 0 0;
    transform: ${({ context }) =>
      context === 'block'
        ? 'translate(-75%, 0) rotate(-45deg)'
        : 'translate(75%, 0) rotate(135deg)'};
    box-shadow: -0.25rem 0.5rem 0.5rem 0 rgba(0, 0, 0, 0.05);
  }
`;

export const CloseButton = styled(FontAwesomeSpriteButton)`
  position: absolute;
  top: 1.25rem;
  left: 1.27rem;
  transform: translate(-50%, -50%);
`;

export const FeedbackIndicatorWrapper = styled(({ blockType, hasFeedback, ...restProps }) => (
  <div {...restProps} />
))`
  z-index: 999;
`;

export const StyledCollapse = styled(({ embedded, ...restProps }) => <Collapse {...restProps} />)`
  position: relative;
  width: ${({ embedded }) => (embedded ? '100%' : `calc(100% + ${MARGIN_OVERLAP * 2}rem)`)};
  margin: ${({ embedded }) =>
    embedded ? '0' : `2rem -${MARGIN_OVERLAP}rem 3rem -${MARGIN_OVERLAP}rem`};
  z-index: 1000;
`;

export const FeedbackTargetAudienceWrapper = styled.div`
  margin-top: 1rem;
`;

export const FeedbackInfoToggleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const FeedbackInfo = styled(({ refined, ...restProps }) => <span {...restProps} />)`
  font-size: ${({ refined }) => (refined ? '1.4rem' : '1.3rem')};
  font-weight: ${({ refined }) => (refined ? 700 : 400)};
  color: ${({ refined, theme }) =>
    refined ? theme.palette.text.primary : theme.palette.grey['500']};
`;
